function getModal(state) {
  return state.modal;
}

export default getModal;
